export default "__VITE_ASSET__Cx$Y1Qkk__"